const firebaseConfig = {
    apiKey: "AIzaSyAPUs8mHSdLWAggpA2J-KOrZQZsLtbcwQM",
    authDomain: "online-grocery-shop05.firebaseapp.com",
    projectId: "online-grocery-shop05",
    storageBucket: "online-grocery-shop05.appspot.com",
    messagingSenderId: "716210785362",
    appId: "1:716210785362:web:a2d1b06959c25a3e1be38b"
  };
  export default firebaseConfig;